import React, { Component } from 'react';
import * as yup from 'yup'
import { mobileNumberRegexp, nationalCodeRegexp } from '../../core/regexp';
import service from '../../core/service';
import { fixNumbers } from '../../core/utils';
import { toast } from 'react-toastify';
interface IProps {
}
interface IState {
  nationalCode: string;
  phoneNumber: string;
  birthdate: any;
  price: string;
  loading: boolean;
  error: any;
}
export class PrePaymentController extends Component<IProps, IState> {
  datePickerRef: any;
  constructor(props: any) {
    super(props);
    this.datePickerRef = React.createRef();
  }
  state: IState = {
    nationalCode:  "",
    phoneNumber:  "",
    birthdate: "",
    price: "",
    loading: false,
    error: []
  };

  handleChange = (value: any) => {
    this.setState({ birthdate: value })
  };

  async createPreFactor() {
    const { nationalCode, phoneNumber, price, birthdate } = this.state;
    const shebaCodeSchema = yup.object({
      nationalCode: yup.string().required("کدملی اجباری می باشد").matches(nationalCodeRegexp, "فرمت وارد شده صحیح نمی باشد. "),
      phoneNumber: yup.string().required("شماره تلفن اجباری می باشد").matches(mobileNumberRegexp, "فرمت وارد شده صحیح نمی باشد. "),
      price: yup.string().required("مبلغ اجباری می باشد").test("email-include-domain", "مبلغ پرداختی نمیتواند کمتر از 1 ریال و بیشتر از 2000000000 ریال باشد  ",
       (value) => {
       if (Number(value) < 1  || Number(value) > 2000000000) {
                    return false;
                }else{
                  return true
                }
       
              }),
      birthdate: yup.string().required("تاریخ تولد اجباری می باشد"),
    });
    try {
      this.setState({ loading: true })
      await shebaCodeSchema.validate({ nationalCode, phoneNumber, price, birthdate }, { abortEarly: false });

      const response = await service.Payment.prePayment(phoneNumber, nationalCode, fixNumbers(birthdate?.convert()?.format("YYYY-MM-DD")), price);
      if (response) {
        this.setState({ loading: false })
        toast.success(response?.message);
        window.location.href = response?.data?.data?.data?.url
      }

    } catch (err: any) {
      this.setState({ loading: false })
      this.setState({ error: err.inner })
    }
  };
}
export default PrePaymentController;